import { render, staticRenderFns } from "./SettingsShippingConfigView.vue?vue&type=template&id=483f6381&"
import script from "./SettingsShippingConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsShippingConfigView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsShippingConfigView.vue?vue&type=style&index=0&id=483f6381&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports